export function changeDaysWeek(value) {
  return {
    type: '@organregistration/ORGAN_DAYSWEEK',
    payload: { value },
  };
}

export function changeBlockDates(value) {
  return {
    type: '@organregistration/ORGAN_BLOCKDATES',
    payload: { value },
  };
}

export function changeCounties(value) {
  return {
    type: '@organregistration/ORGAN_COUNTIES',
    payload: { value },
  };
}

export function changeCountiesProduts(value) {
  return {
    type: '@organregistration/MUNICIPIOPRODUTOS',
    payload: { value },
  };
}

export function resetValues() {
  return {
    type: '@organregistration/ORGAN_RESETVALUES',
  };
}

export function changeQuotas(value) {
  return {
    type: '@organregistration/ORGAN_QUOTAS',
    payload: { value },
  };
}
